<template>
  <div>
  <v-form class="join-developer__form-col">
    <h5 class="join-developer__form-label">Education (optional)</h5>
    <EducationCard
      :education="developer.education"
      :isRegistration="true"
      @delete="deleteEducationElement"
    />
    <h5 class="join-developer__form-label">Experience (optional)</h5>
    <ExperienceCard
      :experience="developer.experience"
      :isRegistration="true"
      @delete="deleteExperienceElement"
    />
    <v-row>
      <v-col class="join-form__col">
        <v-btn
          color="blue"
          class="white--text"
          large
          width="50%"
          @click="submitStep">
          NEXT STEP
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
  <ConfirmDialog ref="confirmDialog" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import EducationCard from '@/components/Developers/Show/EducationCard.vue';
import ExperienceCard from '@/components/Developers/Show/ExperienceCard.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';

export default {
  components: {
    EducationCard,
    ConfirmDialog,
    ExperienceCard,
  },

  computed: {
    ...mapState('developer', [
      'developer',
    ]),
  },

  methods: {
    ...mapActions('developer', [
      'addDeveloperData',
    ]),

    submitStep() {
      this.$emit('submit');
      this.addDeveloperData(this.newDeveloper);
    },

    deleteExperienceElement(experienceId) {
      const experienceData = {};
      experienceData.experience = [...this.developer.experience];

      this.$refs.confirmDialog
        .open({
          message: 'Are you sure you want to delete?',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        })
        .then((confirm) => {
          if (confirm) {
            experienceData.experience.splice(experienceId, 1);
            this.addDeveloperData(experienceData);
          }
        });
    },

    deleteEducationElement(educationId) {
      const educationData = {};
      educationData.education = [...this.developer.education];

      this.$refs.confirmDialog
        .open({
          message: 'Are you sure you want to delete?',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        })
        .then((confirm) => {
          if (confirm) {
            educationData.education.splice(educationId, 1);
            this.addDeveloperData(educationData);
          }
        });
    },
  },
};

</script>
